const carouselItems = [
  {
    title: '2026娱乐圈年中大盘点',
    desc: '上半年最火爆的十大娱乐事件回顾，从明星翻车到CP官宣，每一件都让吃瓜群众津津乐道。',
    tag: '年度策划',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20news%20collage%20with%20dramatic%20red%20and%20dark%20themed%20spotlight%20effect%2C%20floating%20headlines%20in%20warm%20golden%20light%2C%20abstract%20stage%20curtain%20texture%2C%20grand%20award%20show%20atmosphere%2C%20professional%20media%20visual&width=1000&height=600&seq=carousel-01-year-review&orientation=landscape',
  },
  {
    title: '明星代言翻车事件全纪录',
    desc: '从品牌连夜解约到明星道歉声明，近期翻车代言事件深度梳理，品牌方和艺人谁能笑到最后。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20billboard%20being%20taken%20down%20at%20night%20with%20warm%20city%20lights%20background%2C%20luxury%20brand%20advertisement%20in%20spotlight%2C%20cinematic%20moody%20atmosphere%2C%20professional%20documentary%20photography%20style&width=1000&height=600&seq=carousel-02-endorsement&orientation=landscape',
  },
  {
    title: '网络综艺背后的剧本之争',
    desc: '多位离职剪辑师联合爆料综艺节目刻意制造矛盾，真实记录综艺行业不为人知的幕后故事。',
    tag: '独家报道',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20production%20studio%20with%20dramatic%20lighting%20rigs%20and%20cameras%2C%20empty%20director%20chair%20in%20spotlight%2C%20cinematic%20atmosphere%20with%20warm%20and%20cool%20contrast%2C%20professional%20broadcast%20aesthetic&width=1000&height=600&seq=carousel-03-variety&orientation=landscape',
  },
  {
    title: '网红经济：流量背后的真相',
    desc: '从偷税风波到数据造假，带你深度了解网红经济产业链的运作方式和隐藏的灰色地带。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20influencer%20economy%20concept%2C%20smartphone%20with%20glowing%20screen%20showing%20viral%20content%20against%20dark%20background%2C%20money%20and%20followers%20count%20in%20warm%20neon%20glow%2C%20cinematic%20documentary%20style&width=1000&height=600&seq=carousel-04-influencer&orientation=landscape',
  },
  {
    title: '2026最值得关注的吃瓜趋势',
    desc: '从AI换脸到虚拟偶像，从短剧出海到综艺创新，盘点2026年娱乐圈将改变吃瓜方式的五大趋势。',
    tag: '趋势预测',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20entertainment%20concept%20with%20holographic%20screens%20and%20floating%20news%20headlines%2C%20warm%20amber%20and%20red%20neon%20accents%2C%20glowing%20data%20visualization%2C%20cinematic%20futuristic%20aesthetic%2C%20professional%20key%20visual&width=1000&height=600&seq=carousel-05-trends&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">深入解读娱乐圈热点事件</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium text-background-50 bg-accent-500/90 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 flex-1 flex flex-col">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}